// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o9A1c","content":"styles_content__1I1LF"};